import React from "react";
import {
  Modal,
  Paper,
  Typography,
  IconButton,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Button,
  Stack,
  Switch,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { LoadingButton } from "@mui/lab";

import { useEditSection } from "../../../hooks/useSections/usePutSection";

export const EditSection = ({ token, open, close, section, refresh }) => {
 
  const {
        formData,
        isSwitchOn,
        sectionTypes,
        errors,
        loading,
        switchLoading,
        handleChange,
        handleSwitchChange,
        handleUpdate,
      } = useEditSection(token, section, open, refresh, close);

  return (
    <Modal open={open} onClose={close} aria-labelledby="modal-editar-seccion">
      <Paper
        elevation={6}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "80%", md: "60%" },
          maxWidth: "800px",
          maxHeight: "90vh",
          overflowY: "auto",
          borderRadius: "10px",
          p: 3,
          outline: "none",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5" fontWeight="500" id="modal-editar-seccion">
            Editar Sección
          </Typography>
          <IconButton
            onClick={close}
            size="large"
            aria-label="cerrar"
            sx={{
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.04)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Stack spacing={3}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
              <TextField
                fullWidth
                label="Nombre de la sección *"
                name="name_section"
                value={formData.name_section}
                onChange={handleChange}
                error={!!errors.name_section}
                helperText={errors.name_section}
                variant="outlined"
                autoFocus
              />

              <FormControl fullWidth error={!!errors.id_type_section}>
                <InputLabel>Tipo de sección *</InputLabel>
                <Select
                  name="id_type_section"
                  value={formData.id_type_section}
                  onChange={handleChange}
                  label="Tipo de sección *"
                >
                  {sectionTypes.map((type) => (
                    <MenuItem
                      key={type.ID_TIPO_SECCION}
                      value={String(type.ID_TIPO_SECCION)}
                    >
                      {type.NOMBRE_TIPO_SECCION || type.ID_TIPO_SECCION}
                    </MenuItem>
                  ))}
                </Select>
                {errors.id_type_section && (
                  <Typography variant="caption" color="error">
                    {errors.id_type_section}
                  </Typography>
                )}
              </FormControl>
            </Stack>

            <TextField
              name="description"
              label="Descripción"
              multiline
              rows={3}
              value={formData.description}
              onChange={handleChange}
              fullWidth
            />

            <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
              <Typography>Inactivo</Typography>
              <Switch
                checked={isSwitchOn}
                onChange={handleSwitchChange}
                disabled={switchLoading}
                color="primary"
              />
              <Typography>Activo</Typography>
            </Box>
          </Stack>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button variant="outlined" onClick={close} disabled={loading}>
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleUpdate}
            loading={loading}
            loadingPosition="start"
            disabled={loading || switchLoading}
          >
            Guardar cambios
          </LoadingButton>
        </Box>
      </Paper>
    </Modal>
  );
};